import { type MouseEvent } from 'react';

/**
 * A `mousedown` outside the editor blurs it, dropping the caret and the chip's node selection. Every
 * composer-hosted control the user can press guards the press with this so the editor keeps both.
 */
export const preserveWorkspaceAgentComposerFocus = (event: MouseEvent<HTMLElement>) => {
  event.preventDefault();
};
